import { styled } from 'styled-components';
import { scarpaGray100 } from '@habitech/shared';

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${scarpaGray100};
`;
